import { VerticalType } from '@hyphengroup/cms-components/types/cmsTypes';
import { getVerticalByUid } from '@hyphengroup/cms-components/utils/productVertical';

// Apply-v3 always renders a product card, so an unknown uid code falls back to credit card.
export const getProductVertical = (productUid: string): VerticalType =>
  getVerticalByUid(productUid) ?? 'CREDIT_CARD';
